import { SectionValidationErrorUnion, ValidationErrorReason } from "../ISchema";
import ErrorWarning, { IErrorWarning } from "./ErrorWarning";

export const sectionDeleteStrings = {
  UserCannotDeleteSectionWithSession:
    "dimension.section.delete-section.error-modal.user-cannot-delete-section-with-session",
  UserCannotDeleteSection:
    "dimension.section.delete-section.error-modal.user-cannot-delete-section",
  GroupHasEnrollments: "dimension.section.delete-section.error-modal.group-has-enrollments",
  InvalidSection: "dimension.section.delete-section.error-modal.invalid-section",
  ExternalBlock: "dimension.section.delete-section.error-modal.external-block",
};

class SectionDelete extends ErrorWarning {
  private section: SectionValidationErrorUnion;
  constructor(error: SectionValidationErrorUnion) {
    super();
    this.section = error;
  }

  private getMessageExternalValidation = (): IErrorWarning => {
    let invalidInput = null;
    if (this.section.__typename === "ExternalGroupValidation") {
      invalidInput = this.setError(sectionDeleteStrings.ExternalBlock);
    }

    return invalidInput;
  };

  private getMessageInvalidInput = (): IErrorWarning => {
    let invalidInput = null;
    if (this.section.__typename === "InvalidInput") {
      switch (this.section.code) {
        case ValidationErrorReason.InvalidSection:
          invalidInput = this.setError(sectionDeleteStrings.InvalidSection);
          break;
        default:
          invalidInput = null;
          break;
      }
    }
    return invalidInput;
  };

  private getMessageGroupEnrollment = (): IErrorWarning => {
    let invalidComponent = null;
    if (this.section.__typename === "InvalidGroupEnrollment") {
      switch (this.section.reason) {
        case ValidationErrorReason.GroupHasEnrollments:
          invalidComponent = this.setError(sectionDeleteStrings.GroupHasEnrollments);
          break;
        default:
          invalidComponent = null;
      }
    }
    return invalidComponent;
  };

  private getMessageInvalidSectionDeletion = (): IErrorWarning => {
    let invalidInput = null;

    if (this.section.__typename === "InvalidateSectionDeletion") {
      switch (this.section.code) {
        case ValidationErrorReason.UserCannotDeleteSectionWithSession:
          invalidInput = this.setError(sectionDeleteStrings.UserCannotDeleteSectionWithSession);
          break;
        case ValidationErrorReason.UserCannotDeleteSection:
          invalidInput = this.setError(sectionDeleteStrings.UserCannotDeleteSection);
          break;
        default:
          invalidInput = null;
          break;
      }
    }

    return invalidInput;
  };

  public getMessage = () => {
    switch (this.section && this.section.__typename) {
      case "InvalidInput":
        return this.getMessageInvalidInput();
      case "InvalidGroupEnrollment":
        return this.getMessageGroupEnrollment();
      case "ExternalGroupValidation":
        return this.getMessageExternalValidation();
      case "InvalidateSectionDeletion":
        return this.getMessageInvalidSectionDeletion();
      default:
        return null;
    }
  };
}

export default SectionDelete;
